import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
// 引入图标字体CSS
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

Vue.config.productionTip = false
Vue.use(ElementUI)

// 在用户登录后连接 WebSocket
store.watch(
  (state) => state.auth.token,
  (token) => {
    if (token) {
      store.dispatch('websocket/connect')
    } else {
      store.dispatch('websocket/disconnect')
    }
  },
  // 立即执行一次
  { immediate: true }
)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app') 